import { useNavigate } from 'react-router-dom';

export default function VideoSection() {
  const navigate = useNavigate();

  const videos = [
    {
      id: 1,
      title: 'Jackery Solar Generator 2000 Plus Review',
      thumbnail: 'https://public.readdy.ai/ai/img_res/a1e4041a796621845b02e0d9f49aeef6.jpg',
      duration: '12:45',
      views: '45K',
      videoUrl: 'https://youtu.be/Q3fGD6KwGFY'
    },
    {
      id: 2,
      title: 'SetPower Portable Refrigerator - Complete Review',
      thumbnail: 'https://readdy.ai/api/search-image?query=SetPower%20portable%20electric%20cooler%20refrigerator%20with%20digital%20display%20in%20camping%20van%20interior%2C%20professional%20product%20photography%2C%20clean%20minimalist%20background%2C%20studio%20lighting%2C%20tech%20review%20aesthetic%2C%20sharp%20focus&width=800&height=450&seq=video2set&orientation=landscape',
      duration: '18:30',
      views: '78K',
      videoUrl: 'https://youtu.be/5Xe8h8rFQfk'
    },
    {
      id: 3,
      title: 'Jackery Explorer 1000 Pro - Long Term Test',
      thumbnail: 'https://readdy.ai/api/search-image?query=Jackery%20Explorer%20portable%20power%20station%20in%20outdoor%20environment%20with%20camping%20gear%2C%20instructional%20photography%20style%2C%20clean%20background%2C%20professional%20tech%20tutorial%20aesthetic%2C%20bright%20daylight&width=800&height=450&seq=video3jack2&orientation=landscape',
      duration: '15:20',
      views: '62K',
      videoUrl: 'https://youtu.be/fDHdLEbNfQ0'
    },
  ];

  const handleVideoClick = (videoUrl: string) => {
    window.open(videoUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">Latest Video Reviews</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Watch our in-depth video reviews and tutorials to make informed decisions
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {videos.map((video) => (
            <article 
              key={video.id} 
              className="group cursor-pointer"
              onClick={() => handleVideoClick(video.videoUrl)}
            >
              <div className="relative rounded-2xl overflow-hidden mb-4 shadow-lg hover:shadow-2xl transition-shadow duration-300">
                <div className="w-full h-64">
                  <img
                    src={video.thumbnail}
                    alt={video.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors duration-300 flex items-center justify-center">
                  <div className="w-16 h-16 flex items-center justify-center bg-orange-500 rounded-full group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <i className="ri-play-fill text-3xl text-black"></i>
                  </div>
                </div>
                <div className="absolute bottom-4 right-4 bg-black/80 backdrop-blur-sm px-3 py-1 rounded-full">
                  <span className="text-white text-sm font-semibold">{video.duration}</span>
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-orange-500 transition-colors">
                {video.title}
              </h3>
              <div className="flex items-center gap-2 text-gray-600">
                <i className="ri-eye-line"></i>
                <span className="text-sm">{video.views} views</span>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-12">
          <button
            onClick={() => navigate('/videos')}
            className="bg-orange-500 hover:bg-orange-600 text-black font-semibold px-8 py-4 rounded-full transition-all duration-300 hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            View All Videos
          </button>
        </div>
      </div>
    </section>
  );
}
